import axios from "axios";
import { BASE_URL } from "src/constants/app-config-constants";
import { HTTPResponse } from "src/interfaces/httpResponse.interface";

export async function getBranches(): Promise<HTTPResponse> {
  const url = `${BASE_URL}/facility/branch`;
  return axios.get(url);
}
